export default "__VITE_ASSET__CWPRPcdS__"